import {EntityData, identifier} from "@fedeltapointofsale/data-client";

export class TableServiceAreaInfo extends EntityData<TableServiceAreaInfo> {
    @identifier tableServiceArea: number;
}
